// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__xTLWz","notes":"Notes_notes__307wY","note":"Notes_note__1fZV6","markdown":"Notes_markdown__2J0PA"};